export default "__VITE_ASSET__46a032a2__"